import { defineMessages } from 'react-intl';

export default defineMessages({
    closedTabTitleMsg: {
        id: 'portal.views.ServiceRequestList.Tabs.Closed.Ext',
        defaultMessage: 'Closed services: {count}'
    },
    pendingPaymentTabTitleMsg: {
        id: 'portal.views.ServiceRequestList.Tabs.PendingPayment.Ext',
        defaultMessage: 'Pending payment services: {count}'
    },
    openTabTitleMsg: {
        id: 'portal.views.ServiceRequestList.Tabs.Open.Ext',
        defaultMessage: 'Open services: {count}'
    },
    newTabTitleMsg: {
        id: 'portal.views.ServiceRequestList.Tabs.New.Ext',
        defaultMessage: 'New services: {count}'
    }
});
